import { MessageCircle, ArrowRight } from "lucide-react";
import { waLink, MESSAGES } from "@/data/site";
import { useLang } from "@/i18n";

const FinalCta = () => {
  const t = useLang().t;
  return (
  <section data-testid="final-cta" className="bg-[#F5F2EB] py-16 sm:py-24">
    <div className="container-site">
      <div className="rounded-3xl border border-[#EFEBE4] bg-white px-6 py-14 text-center shadow-sm sm:px-12">
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#3E2723]">
          {t.finalCta.title}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base sm:text-lg text-[#5D4037]">
          {t.finalCta.sub}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <a href="#contact" data-testid="final-cta-get-website" className="btn-primary">
            {t.finalCta.cta1} <ArrowRight className="h-4 w-4" />
          </a>
          <a
            href={waLink(MESSAGES.generic)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            className="btn-whatsapp"
          >
            <MessageCircle className="h-4 w-4" /> {t.finalCta.cta2}
          </a>
        </div>
        <p className="mt-6 text-sm text-[#8D6E63]">{t.finalCta.small}</p>
      </div>
    </div>
  </section>
  );
};

export default FinalCta;
